import PageGame from '@/components/PageGame';

export default PageGame;

export async function getStaticProps() {
  return {
    props: {
      path: '/eurojackpot/spielen/iframe',
      gameEurojackpot: 'iframe',
      canonical: {
        path: '/eurojackpot/spielen',
        workspace: 'website',
      },
      noindex: true,
      game: 'Eurojackpot',
      external: true,
      description:
        'Ihr Eurojackpot-Spielschein für Europas Millionenlotterie - Zahlen online tippen und Spielschein sicher abgeben',
      title: 'Eurojackpot online spielen',
    },
  };
}
